<template>
  <div>
    <v-card class="pt-3 px-3 rounded-0" flat>
      <!-- Parent details can be either machine or article and has customer header dropdown. -->
      <template v-if="isParentDetail">
        <CustomerSelect v-model="customerId" externaledit clearable hideIcon class="mb-2" disableAttach>
        </CustomerSelect>
        <QButtonGroup v-model="type" label="Row Type" :list="rowTypes" :edit="true" dense noempty class="mb-3">
        </QButtonGroup>
      </template>

      <!-- If parent and machine -->
      <template v-if="isParentDetail && isMachineMode">
        <v-autocomplete v-if="!loading" hide-details class="mt-0 mb-3" label="Line type"
          v-model="detail.ContractArticle" :items="lineTypes"
          :item-text="(item) => `${item.ArticleNumber}: ${item.ArticleDescription}`" return-object>
        </v-autocomplete>
        <MachineSelect v-model="detail.MachineId" :filter="{ CustomerId: customerId }" class="mb-3" externaledit
          hideIcon disableAttach>
        </MachineSelect>
      </template>

      <!-- Else either child that only allows article detail or parent set to article detail -->
      <template v-else>
        <ArticleSelect v-model="article" externaledit hideIcon returnobject class="mb-3" disableAttach>
        </ArticleSelect>
        <QTextField v-if="!isNew" v-model="detail.ContractDetailGroup" :key="article.ArticleNumber + '-cdg'"
          label="Product text" externaledit class="mb-3">
        </QTextField>
        <QTextArea v-if="!isNew" v-model="detail.ContractDetailArticleSalesText" :key="article.ArticleNumber + '-od'"
          label="Offer description" externaledit class="mb-3">
        </QTextArea>
        <v-row no-gutters>
          <v-col>
            <QTextField v-model="detail.Qty" :key="article.ArticleNumber + '-qty'" label="Qty" externaledit suffix="x"
              :rules="[floatRule]" class="mb-3">
            </QTextField>
          </v-col>
          <v-col v-if="isNew" class="pl-3">
            <QTextField v-model="detail.Price" :key="article.ArticleNumber + '-prc'" label="Price" externaledit
              prefix=",-" reverse :rules="[floatRule]" placeholder="0" class="mb-3">
            </QTextField>
          </v-col>
        </v-row>
      </template>
    </v-card>



    <div v-if="!isNew" class="px-3 pt-2 pb-3" style="background-color: rgb(243 247 255);">
      <QTextArea v-model="detail.ContractDetailComment" label="Internal Comment" externaledit>
      </QTextArea>
    </div>
    <v-divider></v-divider>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import ArticleSelect from "@/components/Inputs/EntityDropdowns/ArticleSelect2.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";

const machineMode = 'machine';
const articleMode = 'article';

export default {
  name: "ContractDetailTypeControl",
  props: {
    contract: Object,
    detail: Object,
    isParentDetail: Boolean,
  },
  components: {
    CustomerSelect,
    MachineSelect,
    ArticleSelect,
  },
  mixins: [clientAPI, ContractMixin],

  data() {
    return {
      loading: false,
      error: null,
      lineTypes: [],
      rowTypes: [
        { value: machineMode, text: this.$t("servicesystem.common_objects.machine.machine") },
        { value: articleMode, text: this.$t("servicesystem.common_objects.article.article") },
      ],
      rowType: null, //infer from detail by default
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.loading = true;
      this.error = null;
      this.getContractLineTypes()
        .then((response) => {
          console.log('lines fetched');
          this.lineTypes = response;
          if (this.isNew) {
            var defaultArticle = response?.[0];
            this.detail.ContractArticle = defaultArticle;
            this.detail.ContractArticleId = defaultArticle.Id;
            if (!this.isParentDetail) {
              this.detail.ArticleId = defaultArticle.Id;
              this.detail.Article = defaultArticle;
            }
          }
        })
        .catch((e) => {
          console.error('getContractLineTypes', e);
          this.lineTypes = [];
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },

  computed: {
    isNew() {
      return !this.detail.Id;
    },

    isMachineMode() {
      return this.type === machineMode;
    },

    type: {
      get() {
        //if not set by buttongroup infer from detail
        if (this.rowType == null) {
          // if parent and either new or was machine detail -> machine detail
          if (this.isParentDetail && (this.isNew || this.detail.MachineId)) {
            return machineMode;
          }
          // else child or already article detail -> article detail
          else {
            return articleMode;
          }
        }
        else {
          return this.rowType;
        }

      },
      set(val) {
        this.rowType = val;
        if (val === machineMode) {
          // switching to machine mode: clear article-based fields
          this.$set(this.detail, 'Article', null);
          this.$set(this.detail, 'ArticleId', null);
        } else if (val === articleMode) {
          // switching to article mode: clear machine selection
          this.$set(this.detail, 'MachineId', null);
        }
      }
    },

    article: {
      get() {
        return this.detail.Article || this.detail.ContractArticle || this.lineTypes?.[0] || {};
      },
      set(val) {
        this.detail.ContractDetailGroup = val.ArticleDescription;
        this.detail.ContractDetailArticleSalesText = val.SalesText;
        this.detail.Article = val;
        this.detail.Price = val.ArticlePrice;
      }
    },

    customerId: {
      get() {
        if (this.detail && this.detail.CustomerId !== undefined && this.detail.CustomerId !== null) {
          return this.detail.CustomerId;
        }
        return this.contract?.CustomerId ?? null;
      },
      set(value) {
        if (this.detail) {
          this.detail.CustomerId = value;
        }
      }
    },
  },

  watch: {},
};
</script>


<style></style>